<div class="flex flex-col gap-y-4">
  <div>
    <p>{{ message1 }}</p>
    @if (items?.length !== 0) {
      <app-show-more
        class="whitespace-pre-line"
        [lines]="3"
        [text]="items.length ? '  • ' + items.join('\n  • ') : ''"
      ></app-show-more>
    }
  </div>

  <p>{{ message2 }}</p>

  <div class="flex justify-end">
    @if (displayRejectButton) {
      <button
        pButton
        class="p-button-secondary mr-2"
        type="button"
        (click)="onReject()"
      >
        @if (rejectIcon) {
          <i [class]="rejectIcon"></i>
        }
        {{ rejectLabel }}
      </button>
    }
    @if (displayAcceptButton) {
      <button
        pButton
        class="confirm-button"
        type="button"
        (click)="onAccept()"
      >
        @if (acceptIcon) {
          <i [class]="acceptIcon"></i>
        }
        {{ acceptLabel }}
      </button>
    }
  </div>
</div>
